// extracted by mini-css-extract-plugin
export var skeleton = "styles-module--skeleton--Celok";
export var shimmer = "styles-module--shimmer--I2oDu";